import { EmDash } from 'dg-web-shared/lib/Punctuation.ts';
import * as Punctuation from 'dg-web-shared/lib/Punctuation.ts';
import {
    IdentificationBox,
    IdentificationIcon,
    IdentificationType,
} from '../common/components/IdentificationItems.tsx';
import { Box } from '@mui/material';
import { LicensePlateType } from 'dg-web-shared/dto/LicensePlateType.ts';
import { PaymentChannel } from '../common/models/PaymentChannel.ts';
import {
    OperatorRefund,
    TransactionRefundBlockedExplanation,
} from '../common/models/OperatorRefund.ts';

export enum TransactionType {
    ONSTREET_RUNNING = 'ONSTREET_RUNNING',
    ONSTREET_TERMINATED = 'ONSTREET_TERMINATED',
    TOM = 'TOM',
}

interface TransactionBase {
    contractExternalId: string;
    createdAt: string;
    zoneName: string;
    extZoneCode: number;
    city: string;
    validFrom: string;
    type: TransactionType;
    zipCode: string;
    licensePlateNr: string;
    licensePlateType: LicensePlateType;
    licensePlateCountry: string;
    paymentChannel: PaymentChannel;
}

export interface OnstreetRunningTransaction extends TransactionBase {
    type: TransactionType.ONSTREET_RUNNING;
}

export interface OnstreetTerminatedTransaction extends TransactionBase {
    type: TransactionType.ONSTREET_TERMINATED;
    validTo: string;
    duration: string;
    priceChf: number;
    amount: number;
    isRefunded: boolean;
    refund: OperatorRefund | null;
    refundBlockedExplanation: TransactionRefundBlockedExplanation | null;
}

export interface TomTransaction extends TransactionBase {
    type: TransactionType.TOM;
    validTo: string;
    duration: string;
    priceChf: number;
    amount: number;
    isRefunded: boolean;
    refund: OperatorRefund | null;
}

export type Transaction =
    | OnstreetRunningTransaction
    | OnstreetTerminatedTransaction
    | TomTransaction;

export function getZoneName(transaction: Transaction) {
    return `${transaction.extZoneCode} | ${getZoneString(transaction.zoneName)} ${EmDash} ${transaction.city}`;
}

export function getZoneString(zoneName: string) {
    return zoneName.replace(/([/])/g, '$1' + Punctuation.Zwsp);
}

export function getTransactionAmount(
    transaction: OnstreetTerminatedTransaction | TomTransaction,
) {
    return `CHF ${transaction.amount.toFixed(2)} ${transaction.isRefunded ? '(R)' : ''}`;
}

export function LicensePlate({ transaction }: { transaction: Transaction }) {
    return (
        <IdentificationBox>
            <IdentificationIcon
                identificationType={IdentificationType.LICENSE_PLATE}
                licensePlateType={transaction.licensePlateType || null}
            />
            <Box sx={{ whiteSpace: 'nowrap' }}>{`${transaction.licensePlateNr}${
                transaction.paymentChannel !== PaymentChannel.EASYPARK &&
                transaction.licensePlateCountry &&
                transaction.licensePlateType
                    ? ` ${transaction.licensePlateCountry}`
                    : ''
            }`}</Box>
        </IdentificationBox>
    );
}
